import contactCss from "../../styles/Dashboard Styles/contact.module.scss";

function ContactList({ users }) {
  // Search Functionality
  function searchUser(e) {
    let inputValue = e.target.value.toLowerCase();
    let contactClass = contactCss.contact;
    let contacts = document.getElementsByClassName(contactClass);
    Array.from(contacts).forEach((contact) => {
      let userName =
        contact.firstElementChild.lastElementChild.textContent.toLowerCase();
      if (userName.startsWith(inputValue)) {
        contact.style.display = "flex";
      } else {
        contact.style.display = "none";
      }
    });
  }

  return (
    <>
      <div className={contactCss.contactContainer}>
        <div className={contactCss.containerElements}>
          <div className={contactCss.searchArea}>
            <input
              type="text"
              placeholder="Search Here"
              name="User Name Search"
              spellCheck="false"
              autoComplete="off"
              onInput={(e) => searchUser(e)}
            />
          </div>

          <div className={contactCss.contacts}>
            {users.length !== 0 ? (
              users.map((val, ind) => {
                return (
                  <div className={contactCss.contact} id={val._id} key={ind}>
                    <div className={contactCss.contactLeft}>
                      <div className={contactCss.contactPicContainer}>
                        <div className={contactCss.contactPic}>
                          <h2>{val.username.charAt(0).toUpperCase()}</h2>
                        </div>
                      </div>
                      <div className={contactCss.contactInfo}>
                        <div className={contactCss.contactName}>
                          <h3>
                            {val.username.charAt(0).toUpperCase() +
                              val.username.slice(1)}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className={contactCss.contactRight}>
                      {val.onlineStatus ? (
                        <div className={contactCss.dot}></div>
                      ) : (
                        <div
                          className={contactCss.dot}
                          style={{ backgroundColor: "rgb(173, 173, 173)" }}
                        ></div>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className={contactCss.noContact}>
                <h2>No Contacts Found</h2>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactList;
